var settings = {};
var changes = false;

const otherMaterials = ['azure-dust', 'charcoal-dust', 'pewter-dust', 'sage-no-chip'];

var material = "bianco-london-plane", 
    edge = "square",
    shape = "rectangle", 
    shapeWallType = "no-walls";

const onScroll = (event) => {
    var scrollPos = $(document).scrollTop();
    $('#worktop_tabs ul.tabs-nav a').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top - 48 <= scrollPos && refElement.position().top + refElement.height() - 48 > scrollPos) {
            $('#worktop_tabs ul li').removeClass("state-active");
            currLink.parent().addClass("state-active");
        }
        else{
            currLink.parent().removeClass("state-active");
        }
    });
}

$(function() {  
  $(document).on("scroll", onScroll);

  $('#worktop_tabs ul.tabs-nav a[href^="#"], .worktop_sidebar .btn_groups a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      $(document).off("scroll");
      
      $('a').each(function () {
          $(this).parent().removeClass('state-active');
      })
      $(this).parent().addClass('state-active');
    
      var isActionClicked = $(this).hasClass('save-btn') || $(this).hasClass('order-btn'),
        $lastTab = $('#worktop_tabs .tabs-panel:last-of-type');
      if(isActionClicked) {
        $lastTab.removeClass('hidden');

        if($(this).hasClass('order-btn')) {
          $lastTab.find('#order-actions').removeClass('display-none');
          $lastTab.find('#save-actions').addClass('display-none');
        } else {
          $lastTab.find('#order-actions').addClass('display-none');
          $lastTab.find('#save-actions').removeClass('display-none');
        }
      }
    
      var target = this.hash,
          menu = target;
      var $target = $(target);
      $('html, body').stop().animate({
          'scrollTop': $target.position().top - 45
      }, 100, 'swing', function () {
          $(document).on("scroll", onScroll);

          if(!isActionClicked) {
            $lastTab.addClass('hidden');
          }
      });
  });
  
  $(".worktop_select .theme-card-wrap input[type=text]").bind('keyup paste', function(){
    this.value = this.value.replace(/[^0-9]/g, '');
  });
  
  $(document).on("change keyup", ".worktop_select_plan input[type=text]", function () {
    validateDimensions($(this));
  });
});

$(document).ready(function(){
  $('input[name="edgeType"]').attr("disabled", true);
  $("#tabs-2 .worktop_select_plan .theme-card-wrap input[type=text]").attr("disabled", true);

  // Style ==> Material
  $(document).on("change", 'input[name="materialType"]', function () {
    material = $(this).val();
	materialCalculation();
    
    var materialColour = $('input[name="materialType"]:checked').parent().find(".small_title").text();
    var materialWood = $('input[name="materialType"]:checked').parent().find(".sub_title").text();
    $('.material_name').html(materialColour + ' / ' + materialWood);

    // changing images of Style tabs
    $(".worktop_select").removeClass("blured_img");

    var materialImage = $('input[name="materialType"]:checked').parent().find("img").attr("alt");

    $("#tabs-3 img.edge-image[alt=square]").attr('src', settings["material"][material]["square_edge_image"]);
    $("#tabs-3 img.edge-image[alt=cutaway]").attr('src', settings["material"][material]["cutaway_edge_image"]);
    
    $('input[name="edgeType"]').attr("disabled", false);
  });

  // Plan ==> Shape
  $(document).on("change", 'input[name="shapeType"]', function () {
    shape = $(this).val();
    
  	$("#tabs-2 .worktop_select_plan .theme-card-wrap input[type=text]").attr("disabled", true);
    $(this).parents('.theme-card-wrap').find('input[type=text]').attr("disabled", false);

    const shapeFormula = parseFormula("shape", shape);
    if (shapeFormula) {
      const priceExclVAT = eval(shapeFormula.exclVatFormula);
      const totalPrice = eval(shapeFormula.totalFormula);

      renderPrice(totalPrice, priceExclVAT);

      $("input:radio[name=materialType][value='" + material + "']").prop("checked", true).change();
      $("input:radio[name=edgeType][value='" + edge + "']").prop("checked", true).change();
    }

    onShapeSelection();
  });
  
  // Style ==> Edge
  $(document).on("change", 'input[name="edgeType"]', function () {
    edge = $(this).val();
    const shapeFormula = parseFormula("edge", shape);
    if (shapeFormula) {
        const totalPriceFormula = shapeFormula.totalFormula.replace("|EDGE|", settings["edge"][edge]["price"]);
        const totalPrice = eval(totalPriceFormula);
      	
      	const exclVatPriceFormula = shapeFormula.exclVatFormula.replace("|EDGE|", settings["edge"][edge]["excl_vat"]);
        const exclVatPrice = eval(exclVatPriceFormula);

        renderPrice(totalPrice, exclVatPrice, '.edge_amount');
    }
    var EdgeName = $('input[name="edgeType"]:checked').parent().find(".small_title").text();
    $('.edge_name').html(EdgeName);
  });

  
  // Cut Outs ==> Plus
  $('.plus_icon_svg').on('click',function() {
    var $qty = $(this).parents(".cut_outs_card").find('.cutouts_plus_minus');
    var currentVal = parseInt($qty.val());
    var newVal;
    
    if (!isNaN(currentVal)) {
      newVal = currentVal + 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal < 1) {
      $(this).parent().find(".minus_icon_svg").addClass("disabled");
    } else {
      $(this).parent().find(".minus_icon_svg").removeClass("disabled");
    }

    cutoutCalculation();
  });
  // Cut Outs ==> Minus
  $('.minus_icon_svg').on('click',function(){
    var $qty = $(this).parents(".cut_outs_card").find('.cutouts_plus_minus');
    var currentVal = parseInt($qty.val());
    var newVal;
    
    if (!isNaN(currentVal) && currentVal > 0) {
      newVal = currentVal - 1;
      $qty.val(newVal);
    } else {
      newVal = 0;
    }

    if (newVal <= 0) {
      $(this).addClass("disabled")
    } else {
      $(this).removeClass("disabled")
    }

    cutoutCalculation();
  });

  // Style ==> Accessories
  $(document).on("change", 'input[name="accessoriesType"]', function () {
    accessories = $(this).val();
	AccessoriesCalculation();

    if(accessories != 'no-accessoriesType'){
      var accessories_name = $('input[name="accessoriesType"]:checked').parent().find(".small_title").text();
      $('.accessories_name').html(accessories_name);
    }

  });
  
  // Request Invoice
  $('#requestInvoiceButton').on('click', function (event) {
    event.preventDefault();
    
    submitQuote('Request Invoice', 1);
  });
  
  // Email Me
  $('#emailMeButton').on('click', function (event) {
    event.preventDefault();
    
    submitQuote('Email Me', 5);
  });
  
  // Save to account
  $('#saveToAccountButton').on('click', function (event) {
    event.preventDefault();
    
    saveToAccount();
  });
  
  // Add to cart
  $('#buyNowButton').on('click', function (event) {
    event.preventDefault();
    
    $("#worktop_loader").css({ opacity: 0.8, display: "flex"});

    $.getJSON('/cart.js', function(cart) {
      if(cart.item_count > 0) {
        var worktopAddedtoCart = 0;
        $.each(cart.items, function(i, item) {
        });
      }

      buyNow();
    });
  });
  
  getPriceSettings();
});

window.onbeforeunload = function () {
    if (changes) {
        var message = "If you leave now, none of this will be saved!\n\nIt only takes a moment to save your changes. And you don’t even need to register. Choose the “save” option. You can continue progress using the code you receive when you click save.";
        return message;
    } else {
        return;
    }
};